// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `GridCol` component is a part of [Grid](#!/Grid) component.
 * @since 0.0.48
 */
const GridCol = _ref => {
  let {
    baseClassName = `${CLS_PREFIX}grid__col`,
    className,
    children,
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
  } = _ref;
  const computedClassName = classNames(baseClassName, {
    [`${baseClassName}--xs-${xs}`]: xs,
    [`${baseClassName}--sm-${sm}`]: sm,
    [`${baseClassName}--md-${md}`]: md,
    [`${baseClassName}--lg-${lg}`]: lg,
    [`${baseClassName}--xl-${xl}`]: xl
  }, className);
  return /*#__PURE__*/_jsx("div", {
    className: computedClassName,
    ...props,
    children: children
  });
};
export default GridCol;